var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalefaccion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicios",
    clipPath: "url(#clip0_781_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0008 6.66699C19.4733 7.04561 19.0459 7.54695 18.7555 8.1277C18.4652 8.70845 18.3205 9.35117 18.3341 10.0003C18.3205 10.6495 18.4652 11.2922 18.7555 11.873C19.0459 12.4537 19.4733 12.955 20.0008 13.3337",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.6675 6.66699C26.1401 7.04561 25.7127 7.54695 25.4223 8.1277C25.1319 8.70845 24.9873 9.35117 25.0009 10.0003C24.9873 10.6495 25.1319 11.2922 25.4223 11.873C25.7127 12.4537 26.1401 12.955 26.6675 13.3337",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3343 6.66699C12.8068 7.04561 12.3794 7.54695 12.089 8.1277C11.7987 8.70845 11.654 9.35117 11.6676 10.0003C11.654 10.6495 11.7987 11.2922 12.089 11.873C12.3794 12.4537 12.8068 12.955 13.3343 13.3337",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M31.3334 16.667H8.66675C7.56218 16.667 6.66675 17.5624 6.66675 18.667V29.667C6.66675 30.7716 7.56218 31.667 8.66675 31.667H31.3334C32.438 31.667 33.3334 30.7716 33.3334 29.667V18.667C33.3334 17.5624 32.438 16.667 31.3334 16.667Z",
    stroke: "#FF7901",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M20 27.4997V20.833",
    stroke: "#FF7901",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M26.6666 20V28.3333M13.3333 20V28.3333",
    stroke: "#FF7901",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_6895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalefaccion);
export default __webpack_public_path__ + "static/media/calefaccion.3248c239c2983ecb70b9042258a39a06.svg";
export { ForwardRef as ReactComponent };